var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-ad351d18\",\"scoped\":true,\"hasInlineConfig\":false}!px2rem-loader?{\"remUnit\":198,\"baseDpr\":1}!less-loader?{\"sourceMap\":false}!sass-resources-loader?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ad351d18\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad351d18",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/amap/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ad351d18", Component.options)
  } else {
    hotAPI.reload("data-v-ad351d18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/libs/amap/index.vue
// module id = 1535
// module chunks = 7